import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import cx from 'classnames';

import { sidebarOpen } from 'actions/sidebarActions';
import { LinkTextLine } from '../linkTemplates';

const stateToProps = ({ sidebar: { componentName, id } }) => ({
    sidebarComponentName: componentName,
    sidebarId: id,
});

@connect(stateToProps, { sidebarOpen })
export class SidebarLink extends Component {
    static propTypes = {
        sidebarId: PropTypes.number,
        sidebarComponentName: PropTypes.string,

        item: PropTypes.object.isRequired,
        componentName: PropTypes.string.isRequired,
        value: PropTypes.string,
        text: PropTypes.element,

        sidebarOpen: PropTypes.func.isRequired,
        icon: PropTypes.string,
        params: PropTypes.object
    };

    static defaultProps = {
        params: {}
    };

    getSidebarCurrent() {
        const { sidebarComponentName, sidebarId } = this.props;
        return sidebarComponentName + sidebarId;
    }

    handler = () => {
        const { item: { id }, value, sidebarOpen, componentName, params } = this.props;

        if (this.getSidebarCurrent() !== componentName + id) {
            sidebarOpen({
                id,
                params: {
                    title: value,
                    ...params
                },
                componentName
            });
        }
    }

    render () {
        const { text,  value, item: { id }, componentName, icon } = this.props;

        const isCurrent = this.getSidebarCurrent() === componentName + id;
        const classes = cx('sidebar-link', {'sidebar-link-current': isCurrent});

        return (
            <LinkTextLine
                icon={icon}
                className={classes}
                handler={this.handler}
                value={text || value}
            />
        );
    }
}
